import type { ReactElement } from "react";

import type { IToast } from "app/components/React/Toast/types";
import { translate } from "app/filters/i18nFilter";
import ManagementToast from "app/pages/sales-intelligence/modules/crm-export/components/Toast/Toast";

import type { ExportExcelService } from "../models/export-service/types";

export const createExportExcelService = (key: string): ExportExcelService => {
    return {
        getToastComponent(text: string): ReactElement {
            return <ManagementToast text={text} />;
        },
        getSuccessToastTitle(): string {
            return translate(`si.table-actions-panel.excel_export.${key}.success`);
        },
        getExportingToastTitle(quantity?: number): string {
            if (!quantity || quantity === 1) {
                return translate(`si.table-actions-panel.excel_export.${key}.in_progress.one`, {
                    quantity,
                });
            }

            return translate(`si.table-actions-panel.excel_export.${key}.in_progress`, {
                quantity,
            });
        },
        getErrorToastTitle(): string {
            return translate(`si.table-actions-panel.excel_export.error`);
        },
        createToast(children: string): IToast {
            return {
                children,
                timestamp: Date.now(),
            };
        },
    };
};
